import { render, staticRenderFns } from "./ListContactsBrainItem.vue?vue&type=template&id=7b6e2d5e&scoped=true"
import script from "./ListContactsBrainItem.vue?vue&type=script&lang=js"
export * from "./ListContactsBrainItem.vue?vue&type=script&lang=js"
import style0 from "./ListContactsBrainItem.vue?vue&type=style&index=0&id=7b6e2d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6e2d5e",
  null
  
)

export default component.exports